'use strict'

import axios, { AxiosRequestConfig } from 'axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.VUE_APP_BASEURL
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config:any) {
    // Do something before request is sent
    return config
  },
  function (error:any) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response:any) {
    // Do something with response data
    return response
  },
  function (error:any) {
    // Do something with response error
    return Promise.reject(error)
  }
)

interface IResp<T> {
  msg: string;
  code: number;
  data: T;
}

export class Http {
  static CancelTokenSource () {
    return axios.CancelToken.source()
  }

  static get<S> (opt: AxiosRequestConfig) {
    return new Promise<S>((resolve, reject) =>
      _axios.get<IResp<S>>(opt.url as string, opt)
        .then((res:any) => res.data)
        .then((res:any) => {
          if (res.code !== 200) {
            reject(res.msg)
          } else {
            resolve(res.data)
          }
        })
        .catch((err:any) => reject(err))
    )
  }

  static post<S> (opt: AxiosRequestConfig) {
    return new Promise<S>((resolve, reject) =>
      _axios.post(opt.url as string, opt.data, opt).then((res:any) => resolve(res.data)).catch((err:any) => reject(err))
    )
  }
}

export default _axios

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: typeof _axios;
  }
}
